import { Component, signal, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LmsService } from '@app/common/services/lms.service';
import { getIsSiriusEnabled } from '@app/common/sirius-util';

@Component({
  selector: 'pl-onboarding-toolkit-card',
  templateUrl: './onboarding-toolkit-card.component.html',
  styleUrls: ['./onboarding-toolkit-card.component.scss'],
})
export class OnboardingToolkitCardComponent {
  private readonly destroyRef = inject(DestroyRef);

  readonly isSiriusEnabled = getIsSiriusEnabled();

  readonly lms_url = `${environment.django_login_url}/saml/sso/learnupon?sp=${environment.learnupon_url}&RelayState=Dashboard`;

  readonly setupUrl = environment.setup_url;

  isLmsLoading = signal(false);

  constructor(private lmsService: LmsService, private snackbar: MatSnackBar) {}

  openLmsPortal(): void {
    if (this.isLmsLoading()) return;
    this.isLmsLoading.set(true);

    this.lmsService
      .openPortal()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.isLmsLoading.set(false))
      )
      .subscribe({
        error: () => {
          this.snackbar.open('Unable to access Telehealth Institute', 'Close', {
            duration: 5000,
          });
        },
      });
  }
}
